import DashboardLayout from '../components/DashboardLayout';
import AuthorisedAppsPanel from '../components/AuthorisedAppsPanel';
import AppsDiscover from '../components/AppsDiscover';

const AppsPage = () => (
  <DashboardLayout title="Apps & connections">
    <div className="section">
      <div className="card hero-card">
        <span className="eyebrow">Connections</span>
        <h3 style={{ margin: '0.4rem 0' }}>Control who can access your identity</h3>
        <p style={{ color: 'var(--dark)', marginBottom: '0.5rem' }}>
          Review OAuth clients with access to your data and discover new integrations in the Gate.haus ecosystem.
        </p>
        <p style={{ color: 'var(--gray)', margin: 0 }}>You can revoke tokens directly from the authorised list.</p>
      </div>
      <div className="dashboard-grid" style={{ alignItems: 'start' }}>
        <AuthorisedAppsPanel />
        <AppsDiscover />
      </div>
    </div>
  </DashboardLayout>
);

export default AppsPage;
